module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况一：添加投资者时，投资者信息表问卷第二题选择“是”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况二：添加投资者时，投资者信息表问卷第二题选择“否”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22678d18"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/Confirm/orgSelfConfirm.vue
// module id = 1029
// module chunks = 1